module.exports = __webpack_public_path__ + "img/row2_col2.0cde5f26.svg";